<template>
  <base-customer :title="title" :fields="fields" :resourceName="resourceName">
    <template slot="entity" slot-scope="{ input }">
      <span>{{ input }}</span>
    </template>
  </base-customer>
</template>

<script>
export default {
  data() {
    return {
      title: "お客様情報の確認・変更",
      resourceName: "customer",
      fields: [
        {
          label: "御社名",
          name: "company_name",
          width: "100%",
          rules: "required|max:64"
        },
        {
          label: "ご担当者名",
          name: "name",
          width: "100%",
          rules: "required|max:32"
        },
        {
          label: "郵便番号",
          name: "postal_code",
          rules: "required|numeric|max:7",
          description: "(住所が自動入力されます)"
        },
        {
          label: "住所",
          name: "address",
          width: "100%",
          type: "textarea",
          rules: "required|max:255"
        },
        {
          label: "電話番号",
          name: "tel_no",
          width: "100%",
          rules: "required|numeric|min:10|max:12"
        },
        {
          label: "メールアドレス",
          name: "mail_address",
          width: "100%",
          rules: "required|email|max:128"
        },
      ]
    };
  }
};
</script>
